import Auth from "@/store/auth";
import store from "@/store/auth";

class Keywords {
  get(groupId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/keywords/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  }

  add(groupId, keywordId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/keywords/";

      let data = {
        keywordId: keywordId
      };

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  }

  remove(groupId, keywordId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/keywords/";

      let data = {
        keywordId: keywordId
      };

      fetch(url, {
        method: "DELETE",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  }
}

export default new Keywords();
